import { Form, ButtonGroup, Button } from 'react-bootstrap';

export default function FontScaleButtonGroup({ fontScale, setFontScale }) {
  return (
    <div className="p-3 card-footer text-muted d-flex text-center justify-content-center align-items-center">
      <Form.Group controlId="fontScaleButtons" className="mb-0">
        <Form.Label>Ajustar tamanho da fonte do PDF</Form.Label>
        <ButtonGroup className="d-flex justify-content-between align-items-center">
          {[0.75, 0.8, 0.85, 0.9, 0.95, 1.0, 1.05, 1.1, 1.15, 1.2].map(
            value => (
              <Button
                key={value}
                variant={fontScale === value ? 'primary' : 'outline-primary'}
                onClick={() => setFontScale(value)}
              >
                {Math.round(value * 100)}%
              </Button>
            )
          )}
        </ButtonGroup>
      </Form.Group>
    </div>
  );
}
